var _g, _path, _path2, _path3, _path4, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3529_127941)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8.5,
    width: 24,
    height: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2741 6.1001H11.7261C11.1622 6.1001 10.6215 6.32409 10.2228 6.72279C9.82409 7.12149 9.6001 7.66225 9.6001 8.2261V32.7741C9.6001 33.3379 9.82409 33.8787 10.2228 34.2774C10.6215 34.6761 11.1622 34.9001 11.7261 34.9001H36.2741C36.8379 34.9001 37.3787 34.6761 37.7774 34.2774C38.1761 33.8787 38.4001 33.3379 38.4001 32.7741V8.2261C38.4001 7.66225 38.1761 7.12149 37.7774 6.72279C37.3787 6.32409 36.8379 6.1001 36.2741 6.1001ZM18.1841 30.6341H13.8541V16.8801H18.1841V30.6341ZM16.0161 14.9741C15.5249 14.9713 15.0456 14.8231 14.6386 14.5482C14.2316 14.2733 13.9151 13.8839 13.7292 13.4293C13.5432 12.9747 13.4961 12.4752 13.5937 11.9938C13.6914 11.5125 13.9295 11.0708 14.2779 10.7246C14.6263 10.3784 15.0695 10.1432 15.5515 10.0487C16.0334 9.95408 16.5326 10.0044 16.986 10.1933C17.4394 10.3822 17.8267 10.7011 18.0991 11.1099C18.3714 11.5186 18.5165 11.9989 18.5161 12.4901C18.5207 12.8189 18.4591 13.1453 18.3349 13.4499C18.2107 13.7544 18.0265 14.0308 17.7932 14.2626C17.5599 14.4944 17.2823 14.6768 16.977 14.7991C16.6717 14.9213 16.3449 14.9808 16.0161 14.9741ZM34.1441 30.6461H29.8161V23.1321C29.8161 20.9161 28.8741 20.2321 27.6581 20.2321C26.3741 20.2321 25.1141 21.2001 25.1141 23.1881V30.6461H20.7841V16.8901H24.9481V18.7961H25.0041C25.4221 17.9501 26.8861 16.5041 29.1201 16.5041C31.5361 16.5041 34.1461 17.9381 34.1461 22.1381L34.1441 30.6461Z",
    fill: "#0A66C2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6615 23.9768L47.5082 39.7031C47.6207 39.903 47.4762 40.1501 47.2467 40.1501H29.5533C29.3238 40.1501 29.1793 39.903 29.2918 39.7031L38.1385 23.9768C38.2532 23.7729 38.5468 23.7729 38.6615 23.9768Z",
    fill: "#FFD62B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6615 23.9768L47.5082 39.7031C47.6207 39.903 47.4762 40.1501 47.2467 40.1501H29.5533C29.3238 40.1501 29.1793 39.903 29.2918 39.7031L38.1385 23.9768C38.2532 23.7729 38.5468 23.7729 38.6615 23.9768Z",
    fill: "url(#paint0_linear_3529_127941)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6615 23.9768L47.5082 39.7031C47.6207 39.903 47.4762 40.1501 47.2467 40.1501H29.5533C29.3238 40.1501 29.1793 39.903 29.2918 39.7031L38.1385 23.9768C38.2532 23.7729 38.5468 23.7729 38.6615 23.9768Z",
    stroke: "#FEC24E",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2239 28.0223C37.2111 27.8483 37.3488 27.7002 37.5231 27.7002H39.2773C39.4516 27.7002 39.5893 27.8483 39.5765 28.0223L39.0899 34.6223C39.0784 34.779 38.9479 34.9002 38.7907 34.9002H38.0097C37.8525 34.9002 37.722 34.779 37.7105 34.6223L37.2239 28.0223Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4002,
    cy: 37.3001,
    r: 1.2,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3529_127941",
    x1: 38.4,
    y1: 22.9001,
    x2: 38.4,
    y2: 40.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3529_127941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8,
    height: 28.8,
    fill: "white",
    transform: "translate(9.6001 6.1001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWarning);
export default __webpack_public_path__ + "static/media/linkedin-warning.d3d4f46ce010bd09b64f7ef85ba4d607.svg";
export { ForwardRef as ReactComponent };